'use client';
import { ButtonProps } from '@mui/material';
import { TextButtonWrapper, TextButtonLabel } from './styles';

interface TextButtonProps extends ButtonProps {
    readonly label: string;
    readonly icon?: React.ReactNode;
    readonly themeColor?: string;
    readonly labelColor?: string;
    readonly withUnderline?: boolean;
}

const TextButton = (props: TextButtonProps) => {
    const { icon, label, themeColor, labelColor, withUnderline, ...buttonProps } = props;
    return (
        <TextButtonWrapper variant='text' {...buttonProps} themeColor={themeColor}>
            {icon && icon}
            <TextButtonLabel
                withUnderline={withUnderline}
                hasIcon={!!icon}
                isDisabled={props.disabled}
                labelColor={labelColor}
            >
                {label}
            </TextButtonLabel>
        </TextButtonWrapper>
    );
};

export { TextButton };
